<div class="text-formatted">
  <div *ngIf="task.is_title" class="title my-color-blue"
        [ngClass]="{'contains-style-color': (for_manager ? task.title_for_manager : (for_coach ? task.title_for_coach : task.title)).includes('color:')}"
       [innerHTML]="(for_manager ? task.title_for_manager : (for_coach ? task.title_for_coach : task.title)) | safeHtml"></div>
  <div class="body" [ngClass]="{'contains-style-color': html.includes('color:')}"
    [innerHTML]="html | safeHtml"></div>
</div>
<div class="text-status" *ngIf="task.task">
    <ion-checkbox *ngIf="!disabled" class="My-checkbox" [(ngModel)]="task.status"
                  (click)="changeStatus(task)"></ion-checkbox>
    <div class="status" *ngIf="disabled" [ngClass]="{completed: task.status}"></div>
</div>
